export class ConsumerDispute 
{
    id: number;
    screeningId: number;
    initiatingUser: number; 
    timestamp: Date;
    isResolved: boolean;
    dateResolved: Date;
    resolutionNote: string;
    resolvingUser: number; 
    reportNumber: number;
    disputeNotes: ConsumerDisputeNote[]; 
    initiatingUserName: string;
    resolvingUserName: string;
    applicantName: string;

    //new stuf
    confirmedFirstName: string;
    confirmedLastName: string;
    confirmedEmail: string;
    confirmedPhone: string;
    confirmedAddress: string;
    confirmedCity: string;
    confirmedState: string;
    confirmedZip: string;
}

export class ConsumerDisputeNote 
{
    id: number;
    disputeId: number;
    note: string; 
    creatingUserId: number; 
    createdDate : Date;
    creatingUserName: string; 
}

export class ConsumerDisputeIdentity {
    firstName: string;
    lastName: string;
    socialSecurityNumber: string;
    dateOfBirth: Date;

    constructor(fn: string, ln: string, ssn: string, dob: Date) {
        this.firstName = fn;
        this.lastName = ln;
        this.socialSecurityNumber = ssn;
        this.dateOfBirth = dob;
    }
}